module.exports = __webpack_public_path__ + "img/kgc-logo-braun.2f62d37d.svg";